export default __webpack_public_path__ + "media/images/dashboard/files-e524e3ec05de2605b9018d32352e9a5b.svg";